document.addEventListener("DOMContentLoaded", () => {

    const popup = document.getElementById("email-popup");

    if (!popup) return;

    const container = popup.querySelector(".popup-container");
    const overlay = popup.querySelector(".popup-overlay");
    const closeBtn = popup.querySelector(".popup-close");

    const STORAGE_KEY = "email_popup_closed";

    const HIDE_DAYS = 30;

    let popupOpened = false;

    /* -----------------------------
       Check Local Storage
    ----------------------------- */

    const lastClosed = localStorage.getItem(STORAGE_KEY);

    if (lastClosed) {

        const difference = Date.now() - Number(lastClosed);

        const days = difference / (1000 * 60 * 60 * 24);

        if (days < HIDE_DAYS) {

            return;

        }

    }

    /* -----------------------------
       Open Popup
    ----------------------------- */

    function openPopup() {

        if (popupOpened) return;

        popupOpened = true;

        popup.classList.add("active");

        document.body.style.overflow = "hidden";

    }

    /* -----------------------------
       Close Popup
    ----------------------------- */

    function closePopup() {

        popup.classList.remove("active");

        document.body.style.overflow = "";

        localStorage.setItem(STORAGE_KEY, Date.now());

    }

    /* -----------------------------
       Timer
    ----------------------------- */

setTimeout(() => {

    openPopup();

}, 120000);

    /* -----------------------------
       Scroll Trigger
    ----------------------------- */

    function handleScroll() {

        if (popupOpened) return;

        const scrollTop = window.scrollY;

        const pageHeight = document.documentElement.scrollHeight - window.innerHeight;

        const percentage = (scrollTop / pageHeight) * 100;

        if (percentage >= 50) {

            openPopup();

            window.removeEventListener("scroll", handleScroll);

        }

    }

    window.addEventListener("scroll", handleScroll);

    /* -----------------------------
       Close Button
    ----------------------------- */

    closeBtn.addEventListener("click", closePopup);

    /* -----------------------------
       Overlay Click
    ----------------------------- */

    overlay.addEventListener("click", closePopup);

    /* -----------------------------
       ESC Key
    ----------------------------- */

    document.addEventListener("keydown", function (event) {

        if (event.key === "Escape") {

            closePopup();

        }

    });

});